import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Lenders from "../views/Lenders.vue";
import Products from "../views/Products.vue";
import About from "../views/About.vue";
import News from "@/views/News"
import MortgageWatch from "@/views/MortgageWatch";
import GettingStarted from "@/views/GettingStarted";
import Remortgage from "@/views/Remortgage";
import Compare from "@/views/Compare";
import Dashboard from "@/views/Dashboard";
import { authGuard } from "@/auth/authGuard";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    beforeEnter: authGuard
  },
  // {
  //   path: "/about",
  //   name: "about",
  //   component: About,
  //   beforeEnter: authGuard
  // },
  // {
  //   path: "/mortgage-watch",
  //   name: "MortgageWatch",
  //   component: MortgageWatch,
  //   beforeEnter: authGuard
  // },
  {
    path: "/mortgage-watch/getting-started",
    name: "getting-started",
    component: GettingStarted,
    beforeEnter: authGuard
  },
  {
    path: "/mortgage-watch/:id/:name",
    name: "mortgage-watch-by-id",
    component: MortgageWatch,
    beforeEnter: authGuard
  },
  {
    path: "/lenders",
    name: "lenders",
    component: Lenders,
    beforeEnter: authGuard
  },
  {
    path: "/news",
    name: "news",
    component: News,
    beforeEnter: authGuard
  },
  {
    path: "/products/remortgage",
    name: "remortgage",
    component: Remortgage,
    beforeEnter: authGuard
  },
  // {
  //   path: "/products/:productType",
  //   name: "products-by-type",
  //   component: Products,
  //   beforeEnter: authGuard
  // },
  // {
  //   path: "/products",
  //   name: "products",
  //   component: Products,
  //   beforeEnter: authGuard
  // },
  {
    path: "/my/dashboard",
    name: "dashboard",
    component: Dashboard,
    beforeEnter: authGuard
  }
];

const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
});

export default router;
